import { inject, Injectable } from '@angular/core';
import { ApiService, RequestBuilder, RequestTypeEnum } from '@client-monorepo/common/network';
import { map, Observable, of } from 'rxjs';
import { UserVersionsResponse } from '../models/user-versions.response';

declare const window: any;
@Injectable({
  providedIn: 'root',
})
export class AbTestService {
  apiService = inject(ApiService);
  private userVersion?: UserVersionsResponse;

  private getVersions(): Observable<UserVersionsResponse> {
    const request = new RequestBuilder(RequestTypeEnum.GET, 'versions');
    return this.apiService.call<UserVersionsResponse>(request);
  }

  getUserChannels(): Observable<string[]> {
    if (this.userVersion) {
      return of(this.userVersion.channels);
    }
    return this.getVersions().pipe(
      map((res) => {
        this.userVersion = res;
        return res.channels;
      }),
    );
  }

  static generatePartitionBasedOnUserId(partitionLength = 20): number {
    const dps = localStorage.getItem('__dp_storage');
    if (!dps) {
      return 0;
    }
    const dpsJson = JSON.parse(dps);
    if (!dpsJson?.auth?.userId) {
      return 0;
    }
    const userId = dpsJson.auth.userId;
    if (!userId) {
      return 0;
    }
    const userNumber: number = parseInt(userId.substr(0, 4).toString(), 16);
    return (userNumber % partitionLength) + 1;
  }

  // This method ensures that the partition will never change at runtime.
  static getPartitionBasedOnUserId(partitionLength = 20): number {
    if (window.partition !== undefined) {
      return window.partition;
    }
    const partition = this.generatePartitionBasedOnUserId(partitionLength);
    window.partition = partition;
    return partition;
  }

  static isShowHome(): boolean {
    let partition = AbTestService.getPartitionBasedOnUserId(20);
    const forcePartition = localStorage.getItem('ab_test_partition');
    if (forcePartition) {
      partition = parseInt(forcePartition);
    }
    return [21].includes(partition);
  }

  static isShowMap(): boolean {
    let partition = AbTestService.getPartitionBasedOnUserId(20);
    const forcePartition = localStorage.getItem('ab_test_partition');
    if (forcePartition) {
      partition = parseInt(forcePartition);
    }
    return [7, 13, 21].includes(partition);
  }

  static callApiWithAbsoluteUrl(): boolean {
    let partition = AbTestService.getPartitionBasedOnUserId(20);
    const forcePartition = localStorage.getItem('ab_test_partition');
    if (forcePartition) {
      partition = parseInt(forcePartition);
    }
    return [21].includes(partition);
  }

  static showWealthWallet(): boolean {
    let partition = AbTestService.getPartitionBasedOnUserId(20);
    const forcePartition = localStorage.getItem('ab_test_partition');
    if (forcePartition) {
      partition = parseInt(forcePartition);
    }
    return [7, 21].includes(partition);
  }
}
